/** @format */

import {ImageViewer, IfElse, If} from 'frontier-utilities';
import SuperAgent from 'superagent';
import React from 'react';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleting: false,
            deletingConfirm: false
        };
    }

    handleDelete = () => {
        this.setState({deleting: true});
    };

    handleDeleteConfirm = () => {
        this.setState({deletingConfirm: true});
        SuperAgent.delete('/account/designs/delete/' + this.props.id)
            .set('accept', 'application/json')
            .end((err, response) => {
                this.props.onRemoveDesign();
            });
    };

    handleDeleteCancel = () => {
        this.setState({deleting: false});
    };

    render() {
        return (
            <React.Fragment>
                <div className="d-flex">
                    <If condition={this.props.isModified}>
                        <IfElse condition={!this.state.deleting}>
                            <button
                                onClick={this.handleDelete}
                                className="p-0 m-0"
                                style={{background: 'transparent', fontSize: '19px'}}>
                                <i className="fa fa-trash color-alert-negative" />
                            </button>
                            <IfElse condition={!this.state.deletingConfirm}>
                                <span>
                                    <button
                                        onClick={this.handleDeleteConfirm}
                                        className="btn btn-outline-success btn-sm mr-2">
                                        Are you Sure?
                                    </button>
                                    <button
                                        onClick={this.handleDeleteCancel}
                                        className="btn btn-outline-secondary  btn-sm">
                                        Cancel
                                    </button>
                                </span>
                                <button className="btn btn-succes  btn-sm" disabled="disabled">
                                    Deleting...
                                </button>
                            </IfElse>
                        </IfElse>
                    </If>
                    <ImageViewer src={this.props.signed_url} filename={this.props.filename}>
                        <button
                            className="color-accent-primary mr-2 ml-2 p-0"
                            style={{maxWidth: '300px', fontSize: '19px'}}>
                            <u style={{textAlign: 'left'}} className="text-truncate">
                                {this.props.filename_without_id}
                            </u>
                        </button>
                    </ImageViewer>
                </div>
            </React.Fragment>
        );
    }
}
